import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import api from "../../lib/api";
import { useLang } from "../../lib/lang";

export default function Projects() {
  const [items, setItems] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    api.get("/projects").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  return (
    <section
      data-testid="projects-section"
      className="bg-[#0A0A0A] text-[#F5F2EB] section-py overflow-hidden"
    >
      <div className="container-x">
        <div className="grid md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-7">
            <p className="overline text-[#B08858]">{t("proj.overline")}</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">
              {t("proj.title_1")}<br />
              <em className="text-[#B08858] not-italic">{t("proj.title_em")}</em>
            </h2>
          </div>
          <div className="md:col-span-5 md:flex md:items-end">
            <p className="text-[#F5F2EB]/70 leading-relaxed text-base md:text-lg">
              {t("proj.lede")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-6">
          {items.slice(0, 6).map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
              className={`group relative overflow-hidden cursor-pointer bg-[#1A1A1A] ${
                i === 0 ? "md:col-span-4 md:row-span-2 aspect-[16/12]" : "md:col-span-2 aspect-[4/3]"
              }`}
              data-testid={`project-card-${i}`}
            >
              <img
                src={p.cover_image}
                alt={p.title}
                width="1200"
                height="900"
                className="hover-zoom-img w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                <p className="overline text-[#B08858] mb-2">{p.location} · {p.category}</p>
                <div className="flex items-end justify-between gap-4">
                  <h3 className="font-display text-xl md:text-2xl lg:text-3xl leading-tight">
                    {p.title}
                  </h3>
                  <span className="w-9 h-9 border border-white/40 group-hover:bg-[#B08858] group-hover:border-[#B08858] flex items-center justify-center transition-all">
                    <ArrowUpRight size={14} />
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link to="/projects" className="btn-sharp outline-light" data-testid="projects-view-all">
            {t("common.view_all_projects")}
          </Link>
        </div>
      </div>
    </section>
  );
}
